<template>
	<div class="homework-row">
		<label>
			{{ 'Game type' | translate }}

			<select v-model="config.type" class="form-control">
				<option :value="type.value" v-for="(type, index) in gameTypes" :key="index">
					{{ type.label | translate }}
				</option>
			</select>
		</label>



		<label>
			{{ 'Level' | translate }}

			<select required v-model="config.options.type" class="form-control">
				<option :value="digit.value" v-for="(digit, index) in additionType" :key="index">
					{{ $t(digit.label).toLowerCase() }}
				</option>

				<option value="multiply" key="multiply">
					{{ $t('Multiplication').toLowerCase() }}
				</option>

				<option value="multiply_quad" key="multiply_quad">
					{{ $t('Squared').toLowerCase() }}
				</option>

				<option value="multiply_50_100" key="multiply_50_100">
					{{ $t('Base 50/100').toLowerCase() }}
				</option>

				<option value="multiply_25x25" key="multiply_25x25">
					{{ $t('25x25').toLowerCase() }}
				</option>

				<option value="divide" key="divide">
					{{ $t('Division').toLowerCase() }}
				</option>
				<option value="negative" key="negative">
					{{ $t('games.negativeNumbers').toLowerCase() }}
				</option>
			</select>
		</label>

		<label>
			{{ 'Calculation method' | translate }}
			<div class="form-check">
				<label class="form-check-label">
					<input class="form-check-input" type="radio" v-model="config.options.calculation_method" value="oral" />
					{{ 'Imaginary abacus' | translate }}
				</label>
			</div>

			<div class="form-check">
				<label class="form-check-label">
					<input class="form-check-input" type="radio" v-model="config.options.calculation_method" value="abacus" />
					{{ 'Abacus' | translate }}
				</label>
			</div>
		</label>

		<label v-if="config.options.type === 'multiply'">
			{{ 'Digit' | translate }}

			<Multiselect placeholder="" :multiple="true" :required="true" v-model="customConfigs.multiply.numbers"
				:options="multiplyDigits" :custom-label="customLabels" />
		</label>

		<template v-else-if="config.options.type === 'multiply_quad'">
			<label>
				{{ 'Digit' | translate }}

				<select required v-model="customConfigs.multiply_quad.numbers" class="form-control">
					<option :value="number.value" v-for="(number, index) in quadNumbers" :key="index">
						{{ number.label }}
					</option>
				</select>
			</label>
		</template>

		<label v-if="config.options.type === 'multiply_50_100'">
			{{ 'Digit' | translate }}

			<select required v-model="customConfigs.multiply_50_100.option" class="form-control">
				<option selected value="more_than_digit">
					>
				</option>

				<option value="less_than_digit">
					&lt;
				</option>

				<option value="universal">
					=/
				</option>
			</select>
		</label>

		<template v-if="config.options.type === 'divide'">
			<label>
				{{ 'divided' | translate }}
				<select required v-model="divideDividend" class="form-control">
					<option :value="1000">1000</option>
					<option :value="100">100</option>
					<option :value="10">10</option>
				</select>
			</label>

			<label>
				{{ 'divider' | translate }}
				<select required v-model="divideDivider" class="form-control">
					<option :value="100">100</option>
					<option :value="10">10</option>
					<option :value="1">1</option>
				</select>
			</label>
		</template>

		<label v-if="isNegative">
			{{ 'Complexity' | translate }}
			<select required v-model="config.options.places" class="form-control">
				<option :value="difficult" v-for="(difficult, index) in difficult" :key="index">
					{{ difficult }}
				</option>
			</select>
		</label>

		<!--		<label class="col-sm-6 col-md-2" v-if="isAnzan">-->
		<!--			{{ 'Calculation method' | translate }}-->
		<!--			<div class="form-check">-->
		<!--				<label class="form-check-label">-->
		<!--					<input-->
		<!--						class="form-check-input"-->
		<!--						type="radio"-->
		<!--						v-model="config.options.calculation_method"-->
		<!--						value="oral"-->
		<!--					/>-->
		<!--					{{ 'Imaginary abacus' | translate }}-->
		<!--				</label>-->
		<!--			</div>-->
		<!--			<div class="form-check">-->
		<!--				<label class="form-check-label">-->
		<!--					<input-->
		<!--						class="form-check-input"-->
		<!--						type="radio"-->
		<!--						v-model="config.options.calculation_method"-->
		<!--						value="abacus"-->
		<!--					/>-->
		<!--					{{ 'Abacus' | translate }}-->
		<!--				</label>-->
		<!--			</div>-->
		<!--		</label>-->

		<label v-if="isAnzan">
			{{ 'Anzan' | translate }} type
			<select required v-model="config.options.digit_type" class="form-control">
				<option :value="digit.value" v-for="(digit, index) in anzanType" :key="index">
					{{ $t(digit.label).toLowerCase() }}
				</option>
			</select>
		</label>

		<label v-if="!isComplexityDisabled && !isNegative">
			{{ 'Complexity' | translate }}
			<select required v-model="config.options.places" class="form-control">
				<option :value="difficult" v-for="(difficult, index) in difficult" :key="index">
					{{ difficult }}
				</option>
			</select>
		</label>

		<label v-if="!isAnzan && !isMultiply && config.options.type !== 'divide' && config.options.type !== 'negative'" v-show="!isTransition">
			{{ 'Digit' | translate }}
			<select required v-model="config.options.digit" class="form-control">
				<option :value="number" v-for="(number, index) in digits" :key="index">
					{{ number }}
				</option>
			</select>
		</label>

		<div class="pro-box" v-if="!isAnzan && !isTransition && isProDigits">
			<p>Pro</p>

			<input type="checkbox" @change="switchProMode" :checked="config.options.option === 'pro'" />
		</div>

		<!-- <label>
			{{ 'Action with numbers' | translate }}
			<input required type="number" min="2" step="1" max="15" :value="config.options.length" @input="onChangeLength"
				@blur="onBlurLength" class="form-control" />
		</label> -->

		<label v-if="!isMultiply && config.options.type !== 'divide'">
			{{ 'Action with numbers' | translate }}
			<input required type="number" min="1" step="1" max="15" v-model="config.options.length" @blur="onBlurLength"
				class="form-control" />
		</label>

		<label>
			{{ 'Number of expressions' | translate }}
			<input type="number" :value="value" @input="onInputRepeat" @blur="onBlurRepeat" min="1" max="10" step="1"
				class="form-control" />
		</label>

		<p>
			{{ 'Timer' | translate }}
			<input type="checkbox" v-model="config.options.isTimerEnabled" class="form-checkbox" />

			<input type="number" step="1" max="300" min="10" v-model="config.options.timerCount"
				:disabled="!config.options.isTimerEnabled" class="form-control" />
		</p>
	</div>
</template>

<script>
import {
	LABELED_ADDITION_TYPES,
	PLACES,
	getAdditionalDigits,
	getAdditionalProDigits,
} from '../../../Games/gameConfig'
import { DEFAULT_ADDITION_OPTIONS } from '@/components/Dashboard/Homework/Create'
import Multiselect from 'vue-multiselect'

export default {
	name: 'columns',

	components: {
		Multiselect
	},

	data() {
		return {
			gameMode: null,

			customConfigs: {
				multiply: {
					numbers: []
				},

				multiply_50_100: {
					option: 'more_than_digit',
				},

				multiply_quad: {
					numbers: [11, 19],
				},
			},
		}
	},

	props: {
		config: {
			options: Object,
		},

		onInputRepeat: Function,
		onBlurRepeat: Function,
		value: String,
		gameTypes: Array,
	},

	created() {
		// if (this.config.id || this.config.is_created) {
		// 	this.config.id = undefined
		// 	// // this.config.is_created = true
		// 	// // console.log('options columns', this.config.options)
		// 	// if ( //!this.config.options.digit || 
		// 	// 	!this.config.options.places
		// 	// 	|| !this.config.options.type
		// 	// 	|| this.config.options.type == 'abacus_random_2'
		// 	// 	|| (this.config.options.type.includes("multiply") && !this.config.options.calculation_method)
		// 	// ) {
		// 	// 	this.config.options = { ...DEFAULT_ADDITION_OPTIONS }
		// 	// }
		// }

		// else {
		// 	// small super-fast fix for make new config object
		// 	this.config.options = { ...DEFAULT_ADDITION_OPTIONS }
		// }

		// this.config.is_created = true

		if (this.config.options.type == 'multiply') {
			this.customConfigs.multiply.numbers = this.config.options.numbers
		}

		if (this.config.options.type == 'multiply_quad') {
			this.customConfigs.multiply_quad.numbers = this.config.options.numbers
		}

		if (this.config.options.type == 'multiply_50_100') {
			this.customConfigs.multiply_50_100.option = this.config.options.option
		}

		// if (this.config.id) {
		// 	this.config.id = undefined
		// } else {
		// 	this.config.options = { ...DEFAULT_ADDITION_OPTIONS }
		// }
	},

	methods: {
		customLabels(option) {
			const labels = {
				10: '10-19',
				20: '20-29',
				30: '30-39',
				40: '40-49',
				50: '50-59',
				60: '60-69',
				70: '70-79',
				80: '80-89',
				90: '90-99',
			}

			return labels[option] ? labels[option] : option
		},

		switchProMode() {
			this.config.options.option = this.config.options.option == 'pro' ? '' : 'pro'
		},

		// onChangeLength({ target }) {
		// 	const {
		// 		value,
		// 		validity: { valid },
		// 	} = target
		// 	this.config.options.length =
		// 		value && !valid ? this.config.options.length : value
		// 	target.value = this.config.options.length
		// },

		onBlurLength() {
			if (
				!this.config.options.length ||
				Number(this.config.options.length <= 2)
			) {
				this.config.options.length = 2
			}
		},

		onChangeSpeed({ target }) {
			const {
				value,
				validity: { valid },
			} = target
			this.config.options.speed =
				value && !valid ? this.config.options.speed : value
			target.value = this.config.options.speed
		},

		onBlurSpeed() {
			if (
				!this.config.options.speed ||
				Number(this.config.options.speed <= 0.1)
			) {
				this.config.options.speed = 0.1
			}
		},

	},

	watch: {
		'config.options.length'() {
			if (this.config.options.length > 15) {
				this.config.options.length = 15
			}
		},

		// 'config.options.places'() {
		// 	const firstDigit = this.digits[0]
		// 	if (
		// 		this.config.options.type === 'elementary' &&
		// 		+this.config.options.places === 1 &&
		// 		firstDigit > +this.config.options.digit
		// 	) {
		// 		this.config.options.digit = firstDigit.toString()
		// 	}
		// },

		'config.options.type'(value) {
			// if (this.config.options.type == "fifty" || this.config.options.type == "hundred") {
			// 	this.config.options.places = 10
			// }

			// if (this.config.options.type == "hundred" && this.config.options.places < 100) {
			// 	this.config.options.places = 100
			// }

			if (this.config.options.type == "anzan" && this.config.options.type == "fifty" && this.config.options.type == "hundred") {
				this.config.options.option = ''
			}

			if (this.config.options.type != "anzan") {
				delete this.config.options.digit_type
			}

			if (this.config.options.type == "anzan" && this.config.options.digit_type == undefined) {
				this.config.options.digit_type = 'anzan_random'
			}

			//Multiply configs

			if (this.config.options.type.includes('multiply')) {
				this.config.options.length = 1
				this.config.options.isTimerEnabled = true
			} else if (this.config.options.type == 'divide') {
				this.config.options.length = 1
				this.config.options.numbers = [100, 10]
				this.config.options.isTimerEnabled = true
			} else if (this.config.options.type == 'negative') {
				this.config.options.length = 10
				this.config.options.places = 1
				this.config.options.isTimerEnabled = true
			} else {
				this.config.options.length = 2
				this.config.options.isTimerEnabled = true
			}

			if (this.config.options.type == 'multiply') {
				this.config.options.numbers = []
			} else if (this.config.options.type == 'multiply_quad') {
				this.config.options.numbers = [11, 19]
			} else if (this.config.options.type == 'divide') {
				this.config.options.numbers = [100, 10]
			} else {
				this.config.options.numbers = null
			}

			if (this.config.options.type == 'multiply_50_100') {
				this.config.options.places = 50
				this.config.options.option = 'more_than_digit'
			}

			// else {
			// 	this.config.options.places = 1
			// }

			if (this.config.options.type == "fifty" || this.config.options.type == "hundred") {
				this.config.options.places = 10
			}

			// if (this.config.options.type == "elementary" || this.config.options.type == "small_friends" || this.config.options.type == "big_friends") {
			// 	this.config.options.digit = 3
			// }

			// if (this.config.options.type == "family") {
			// 	this.config.options.digit = 6
			// }
		},

		isProDigits(value) {
			if (!value) {
				this.config.options.option = ''
			}
		},

		'customConfigs.multiply.numbers'(value) {
			this.config.options.numbers = value
		},

		'customConfigs.multiply_quad.numbers'(value) {
			this.config.options.numbers = value
		},

		'customConfigs.multiply_50_100.option'(value) {
			this.config.options.option = value
		},

	},
	computed: {
		divideDividend: {
			get() {
				return Array.isArray(this.config.options.numbers)
					? this.config.options.numbers[0]
					: 100
			},
			set(value) {
				if (!Array.isArray(this.config.options.numbers)) {
					this.config.options.numbers = [100, 10]
				}

				this.config.options.numbers = [value, this.config.options.numbers[1]]
			},
		},

		divideDivider: {
			get() {
				return Array.isArray(this.config.options.numbers)
					? this.config.options.numbers[1]
					: 10
			},
			set(value) {
				if (!Array.isArray(this.config.options.numbers)) {
					this.config.options.numbers = [100, 10]
				}

				this.config.options.numbers = [this.config.options.numbers[0], value]
			},
		},

		isMultiply() {
			return this.config.options.type.includes('multiply')
		},

		isNegative() {
			return this.config.options.type === 'negative'
		},

		isAnzan() {
			return this.config.options.type === 'anzan'
		},

		anzanType() {
			return [
				{ value: 'anzan_random', label: 'Random numbers' },
				{ value: 'anzan_minus', label: 'Only subtraction' },
				{ value: 'anzan_plus', label: 'Only add' },
			]
		},

		isTransition() {
			return this.config.options.type.includes('fifty') || this.config.options.type.includes('hundred')
		},

		additionType() {
			return LABELED_ADDITION_TYPES
		},

		difficult() {
			if (this.isTransition) {
				if (this.config.type.includes('hundred')) {
					return PLACES.filter(i => i !== 1 && i !== 10)
				}



				return PLACES.filter(i => i !== 1)
			};

			if (this.config.options.type == 'multiply_50_100') {
				return [50, 100]
			}

			return PLACES
		},

		digits() {
			const { type, places } = this.config.options

			return getAdditionalDigits(type, +places) || []
		},

		isProDigits() {
			const { type, places, digit } = this.config.options

			if (this.config.options.type == "anzan"
				|| this.config.options.type == "fifty"
				|| this.config.options.type == "hundred"
				|| this.config.options.type == "divide"
				|| this.config.options.type == "negative"
				|| this.config.options.type.includes("multiply")) {
				return false
			}

			return getAdditionalProDigits(type, +places).includes(Number(digit))
		},

		isComplexityDisabled() {
			return this.config.options.type == 'multiply_25x25' || this.config.options.type == 'multiply_quad' || this.config.options.type == 'divide'
		},

		multiplyDigits: () => [
			2,
			3,
			4,
			5,
			6,
			7,
			8,
			9,
			11,
			12,
			13,
			14,
			15,
			16,
			17,
			18,
			19,

			10,
			20,
			30,
			40,
			50,
			60,
			70,
			80,
			90,
			// 100,
		],

		quadNumbers: () => [
			{ value: [11, 19], label: '11-19' },
			{ value: [20, 29], label: '20-29' },
			{ value: [30, 70], label: '30-70' },
			{ value: [80, 120], label: '80-120' },
		],


	},

	// created() {
	// 	if (this.config.options.type == 'multiply') {
	// 		this.customConfigs.multiply.numbers = this.config.options.numbers
	// 	}

	// 	if (this.config.options.type == 'multiply_quad') {
	// 		this.customConfigs.multiply_quad.numbers = this.config.options.numbers
	// 	}

	// 	if (this.config.options.type == 'multiply_50_100') {
	// 		this.customConfigs.multiply_50_100.option = this.config.options.option
	// 	}
	// }
}
</script>

<style lang="scss" scoped>
.form-checkbox {
	margin-top: 3px;
	margin-left: 5px;
}

.pro-box {
	margin-right: 30px;
}

.not-equal::before {
	content: '\2260';

	margin: 0 4px;

	font-family: 'Times New Roman', Times, serif;
}
</style>
